import { Card, DatePicker } from "antd"
import { InvoiceSendOptions } from "../../../domain/invoicing/invoicingApi"
import dayjs from "dayjs"

type Props = {
  options: InvoiceSendOptions
  onUpdate: (updated: InvoiceSendOptions) => void
  defaultDueDate: string
  documentLabel?: string
}

const DueDateCard = ({ options, onUpdate, defaultDueDate, documentLabel = 'Invoice' }: Props) => {
  return <Card title={`${documentLabel} Due Date`}>
    <DatePicker
      value={options.dueOn ? dayjs(options.dueOn) : null}
      onChange={(value) => onUpdate({
        ...options,
        dueOn: value?.toISOString() ?? defaultDueDate,
      })}
    />
  </Card>
}

export default DueDateCard
